// Utils
import { toFixedIfDecimalNumber } from "../../common-utils/number-utils/NumberUtils";

/**
 * Media CPAI
 * Formula will vary according to TG applied
 * CPI = site MOP / TG Imp. of Stretch
 * CPI = site MOP / Generic Imp. of Stretch
 */
export function getMediaCPAI(
  media = {},
  roadStretchOtsSplit = {},
  targetGroupId = ""
) {
  // media price
  const { pricing = {} } = media || {};
  const { price } = pricing || {};

  // if no price present return cpai as 0
  if (!price || price === "0") {
    return 0;
  }

  // road stretch impressions
  const { ots, otsLit, targetOts, targetOtsLit } = roadStretchOtsSplit || {};
  const finalGenericOts = otsLit ?? ots;
  const finalTargetOts = targetOtsLit ?? targetOts;

  // final impressions for dividing
  const finalImpressions = targetGroupId ? finalTargetOts : finalGenericOts;

  // avoid divide by zero
  if (!finalImpressions) {
    return 0;
  }

  // CPAI
  const cpai = price / finalImpressions;
  const toFixedMediaCpai = cpai === 0 ? 0 : toFixedIfDecimalNumber(cpai, 3);
  return toFixedMediaCpai;
}

/**
 * City CPAI
 */
export function getCityMediasCPAI(mediaList = [], cityPlan = {}) {
  // if no media present then just return 0
  if (mediaList.length === 0) {
    return { staticCpai: 0, doohCpai: 0 };
  }

  // plan data
  const { roadStretchOtsMap = {}, targetGroupId } = cityPlan || {};

  // calculating cpai split
  const cpaiSplit = mediaList.reduce(
    (acc, media) => {
      const { roadStretchId, isDigital = false } = media || {};
      const roadStretchOtsSplit = roadStretchOtsMap[roadStretchId] || {};

      // media cpai
      const mediaCPAI = getMediaCPAI(media, roadStretchOtsSplit, targetGroupId);

      // skip if no value
      if (!mediaCPAI) {
        return acc;
      }

      // checking is digital media or not and adding cpai
      if (isDigital) {
        acc.doohCpai += mediaCPAI;
      } else {
        acc.staticCpai += mediaCPAI;
      }

      return acc;
    },
    { staticCpai: 0, doohCpai: 0 }
  );

  const { staticCpai = 0, doohCpai = 0 } = cpaiSplit;

  return {
    staticCpai: toFixedIfDecimalNumber(staticCpai, 3),
    doohCpai: toFixedIfDecimalNumber(doohCpai, 3),
  };
}
